import {NgModule} from "@angular/core";
import {SharedModule} from "./shared.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {AngularSplitModule} from "angular-split";
import {ColorPickerModule} from "ngx-color-picker";
import {AudiogramEditorComponent} from "../storyboard/storyboard-edit/audiogram-editor/audiogram-editor.component";
import {TextEditorComponent} from "../storyboard/storyboard-edit/text-editor/text-editor.component";
import {StoryboardEditComponent} from "../storyboard/storyboard-edit/storyboard-edit.component";
import {PreviewComponent} from "../storyboard/storyboard-edit/preview/preview.component";
import {TimelineComponent} from "../storyboard/storyboard-edit/timeline/timeline.component";
import {StoryboardEditHeaderComponent} from "../storyboard/storyboard-edit/storyboard-edit-header/storyboard-edit-header.component";
import {ClipComponent} from "../storyboard/storyboard-edit/timeline/video-layer/clip/clip.component";
import {WaveformComponent} from "../storyboard/storyboard-edit/timeline/audio-track/waveform/waveform.component";
import {VideoLayerComponent} from "../storyboard/storyboard-edit/timeline/video-layer/video-layer.component";
import {ControlBarComponent} from "../storyboard/storyboard-edit/timeline/control-bar/control-bar.component";
import {AudioTrackComponent} from "../storyboard/storyboard-edit/timeline/audio-track/audio-track.component";
import {ExtendableDirective} from "../storyboard/storyboard-edit/timeline/video-layer/directives/extendable.directive";
import {EditableDivDirective} from "../storyboard/storyboard-edit/text-editor/directives/editable-div.directive";
import {CreateVideoLayerComponent} from "../storyboard/storyboard-edit/timeline/create-video-layer/create-video-layer.component";
import {TimelineDragDirective} from "../storyboard/storyboard-edit/timeline/video-layer/directives/timeline-drag.directive";
import {PreviewRenderComponentComponent} from "../storyboard/storyboard-edit/preview/preview-render-component/preview-render-component.component";
import {ClipMenuComponent} from "../storyboard/storyboard-edit/timeline/video-layer/clip/clip-menu/clip-menu.component";
import {TranscribeEditorComponent} from "../storyboard/storyboard-edit/transcribe/transcribe-editor/transcribe-editor.component";
import {TranscribeSentenceComponent} from "../storyboard/storyboard-edit/transcribe/transcribe-editor/transcribe-sentence/transcribe-sentence.component";
import {Ng5SliderModule} from "ng5-slider";

@NgModule({
  imports: [
    SharedModule,
    FormsModule,
    AngularSplitModule,
    ColorPickerModule,
    ReactiveFormsModule,
    Ng5SliderModule
  ],
  entryComponents: [AudiogramEditorComponent,TextEditorComponent],
  declarations: [StoryboardEditComponent, PreviewComponent, TimelineComponent, StoryboardEditHeaderComponent,
    AudioTrackComponent, ControlBarComponent, VideoLayerComponent, WaveformComponent, ClipComponent,
    ExtendableDirective, CreateVideoLayerComponent, AudiogramEditorComponent, TextEditorComponent,
    EditableDivDirective, TimelineDragDirective, PreviewRenderComponentComponent, ClipMenuComponent,
    TranscribeEditorComponent, TranscribeSentenceComponent],
  exports: [
    FormsModule,
    SharedModule,
    AngularSplitModule,
    ColorPickerModule,
    StoryboardEditComponent, PreviewComponent, TimelineComponent, StoryboardEditHeaderComponent,
    AudioTrackComponent, ControlBarComponent, VideoLayerComponent, WaveformComponent, ClipComponent,
    ExtendableDirective, CreateVideoLayerComponent, AudiogramEditorComponent, TextEditorComponent,
    EditableDivDirective, TimelineDragDirective, PreviewRenderComponentComponent, ClipMenuComponent,
    TranscribeEditorComponent, TranscribeSentenceComponent,ReactiveFormsModule
  ]
})
export class EditSharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/EditShared.module.ts